<template>
    <div v-if="isCookeBarVisible()" class="cookie-bar-cont">
        <div class="cookie-bar" @click="hideCookieBar">
            <div>
                <span>Futurum.cc uses cookies (and similar techniques) to make our site more personal for you, for analysis and to provide you with relevant messages on our site or third party sites. By continuing to use our site you agree to this.</span>
                <a href="https://www.futurum.cc/html/cookie_statement.html" onclick="window.open('https://www.futurum.cc/html/cookie_statement.html', '', 'width=800, height=600, scrollbars=yes, resizable=yes');return false">Read more</a>
            </div>

            <div class="svg-cont" @click="hideCookieBar">
                <svg-icon icon-name="icon-cross"></svg-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import SvgIcon from './SvgIcon.vue';

    let that;
    let VueCookie = require('vue-cookie');
    Vue.use(VueCookie);

    export default{
        data() {
            return {
                isHideCookieBar: true,
            };
        },
        components: {
            'svg-icon': SvgIcon
        },
        computed:{
            gdprCookieExists(){
                return this.$root.gdprCookieExists;
            }
        },
        methods:{
            isCookeBarVisible(){
                return !this.gdprCookieExists
            },
            hideCookieBar(event){
                let currentLink = window.location.href;
                event.preventDefault();
                if (this.isHideCookieBar || window.location.href.indexOf('klantenservice/veiligheid-en-privacy') !== -1) {
                    this.$root.gdprCookieExists = true;
                    this.$cookie.set('__Host-gdprCookie', true, { expires: '1Y', secure: true });
                    $('body').removeClass('showCookieBar');
                } else {
                    this.isHideCookieBar = true;
                }
            },
            showCookieBar(){
                this.isHideCookieBar = false;
                this.$cookie.delete('__Host-gdprCookie');
            }
        },
        created(){
            that = this;
        }
    }
</script>
